// extracted by css-extract-rspack-plugin
export default {"sortableField":"zb7zv","active":"BAP8r","card":"_V9I8","draggable":"z5OUv","grabber":"XuVOF","icon":"juRBn","label":"AHBg1"};